// extracted by mini-css-extract-plugin
export var icon = "logo-small-module--icon--C7Yss";
export var wrapper = "logo-small-module--wrapper--lN1qm";